import { useEffect, useState } from "react";
import "../../../../style/formComment.scss";
import { useLanguage } from "@/app/utils/LanguageContext";
import { useMyContext } from "@/app/utils/MyContext";
import { getFormComments } from "@/app/utils/request/requestList";
import { dateFormat, formattedDate, toDate } from "@/app/utils/DayJS";
import NoInformation from "@/app/ui/Common/NoInformation";
import { getSearchParams, setRacesDetailLoading } from "@/app/utils/Common";

export default function FormComment(props: any) {
  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const { state: lang } = useLanguage();
  const [raceTitleData, setRaceTitleData] = useState<any>({});
  const [contentData, setContentData] = useState<any>([]);
  const { b_cid } = getSearchParams(new URLSearchParams(window.location.search));
  const { t } = lang;

  const parseCSV = (csv: any) => {
    if (!csv) return;
    const lines = csv?.split(/\r\n|\n/);
    const jsonArray: any = [];
    lines.forEach((line: any, index: any) => {
      const fields = line.split("\t");
      jsonArray.push({
        title: fields[0],
        content: fields[1],
      });
    });
    console.log(jsonArray);
    return jsonArray;
  };
  useEffect(() => {
    getFormComments(
      lang.langCode,
      myContextState.season,
      myContextState.selectedMeeting?.displayName,
      myContextState.selectedRace?.displayName
    ).then((res: any) => {
      const data = res?.item;
      const content = data?.children?.filter((item: any) => item?.content)?.[0]?.content.value;
      setRaceTitleData({
        raceName: data?.raceName.value,
        date: data?.raceDatetime.value,
        venueCode: data?.venueCode.value,
      });
      setContentData(parseCSV(content));
    }).finally(() => {
      setRacesDetailLoading(props.setRacesDetailLoading)
    });
  }, [
    myContextState.selectedMeeting,
    myContextState.selectedRace?.displayName,
  ]);
  const renderTitle = (data: any) => {
    if (!data) return;
    const title = `${data.raceName ?? data.raceName} ${
      data.venueCode ? `(${data.venueCode})` : ""
    }`;
    const date = formattedDate(
      toDate(data.date, "YYYYMMDDTHHmmssZ"),
      dateFormat.display.fulldatetime
    );
    return (
      <>
        <p>{title}</p>
        <p>{date}</p>
      </>
    );
  };
  return <div id="form_comments_table" className="form-comment">
      <div className="form-comment-row-flow">
        <div className="form-comment-cell-flow">
          <div className="form-comment-title">{t("formComments")}</div>
        </div>
      </div>
      {
         contentData?.length ? <>
          <div className="form-comment-row">
            <div className="form-comment-cell">
              <div className="form-comment-summary">
                {renderTitle(raceTitleData)}
              </div>
            </div>
          </div>

          {contentData?.map((item: any, idx: number) => (
            <div className="form-comment-row" key={idx}>
              <div className="form-comment-cell">
                <div className="form-comment-cell-1">
                  <a href="javascript:;">{item?.title}</a>
                </div>
              </div>
              <div className="form-comment-cell">{item?.content}</div>
            </div>
          ))}
        </>: 
        <NoInformation/>
      }
    </div>;
}
